import React, { useEffect, useRef, useState } from "react";
import { DialogModalWithForm } from "../Components/DialogModal";
import { StyledPrimaryButton } from "../Components/StyledComponents/Buttons";
import userServerClient from "../ServerClients/UserServerClient";

export const PasswordResetForm: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [mail, setMail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const active = useRef(true);
  const pending = useRef(false);

  useEffect(() => {
    active.current = true;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      active.current = false;
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose]);

  const sendEmail = async () => {
    if (pending.current || sent || !mail.trim()) return;
    pending.current = true;
    setSending(true);
    setError("");
    try {
      await userServerClient.sendPasswordResetEmailAsync(mail.trim());
      if (active.current) setSent(true);
    } catch {
      if (active.current) setError("Не удалось отправить письмо. Проверьте адрес электронной почты и попробуйте ещё раз.");
    } finally {
      pending.current = false;
      if (active.current) setSending(false);
    }
  };

  return (
    <div role="dialog" aria-modal="true" aria-label="Сброс пароля">
      <DialogModalWithForm className="auth-form" onCloseClick={onClose} onSubmit={sendEmail} width="min(410px, 100vw)">
        <DialogModalWithForm.Header>Сброс пароля</DialogModalWithForm.Header>
        <DialogModalWithForm.Body>
          {sent ? (
            <p role="status">Письмо для сброса пароля отправлено. Проверьте почту и папку «Спам».</p>
          ) : (
            <>
              <p>Введите адрес электронной почты вашей учётной записи. Мы отправим ссылку для сброса пароля.</p>
              <div>
                <label htmlFor="password-reset-email">Электронная почта</label>
                <input id="password-reset-email" name="email" type="email" autoComplete="email"
                  placeholder="name@example.com" autoFocus required maxLength={255}
                  value={mail} disabled={sending}
                  onChange={(event) => { setMail(event.target.value); setError(""); }} />
              </div>
              {error && <p role="alert">{error}</p>}
              <div>
                <StyledPrimaryButton type="submit" disabled={sending || !mail.trim()} aria-busy={sending}>
                  {sending ? "Отправляем…" : "Отправить письмо"}
                </StyledPrimaryButton>
              </div>
            </>
          )}
        </DialogModalWithForm.Body>
      </DialogModalWithForm>
    </div>
  );
};
